import React from 'react';
import { FeedbackDialog } from 'modules/feedback';
import type { SessionEndFlow } from '../useSessionEndFlow';
import { AnalysingResultsDialog } from './AnalysingResultsDialog';
import { SessionEndOfferDialog } from './SessionEndOfferDialog';

/** Mounts whichever step of the end-of-test sequence is current; renders nothing otherwise. */
export function SessionEndDialogs({ flow }: { flow: SessionEndFlow }) {
  return (
    <>
      <AnalysingResultsDialog open={flow.phase === 'analysing'} onDone={flow.next} />
      {flow.offer ? <SessionEndOfferDialog open={flow.phase === 'offer'} offer={flow.offer} onClose={flow.next} /> : null}
      {flow.attemptId ? (
        <FeedbackDialog open={flow.phase === 'feedback'} attemptId={flow.attemptId} onClose={flow.next} />
      ) : null}
    </>
  );
}
